import styles from './entry.module.less';
import { CollectListContext, MapView, findCurCItyInfo, levelEnum, mapCon, networkMapContainer } from './ts-config';
import { MapHelpfulContextProvider } from '@/common/components/AMap/MapHelpfulContext';
import { useDispatch, useSelector } from 'react-redux';
import KeepAlive from 'react-activation';
import SiteView from './components/SiteView';
import AMap from '@/common/components/AMap';
import { FC, useEffect, useMemo, useRef, useState } from 'react';
import cs from 'classnames';
import AllLevelTop from './components/AllLevelTop';
import useCurLocation from '@/common/components/Map/V2AMap/hooks/useCurLocation';
import Loading from '@/common/components/AMap/Loading';
import { curSelectDistrictType } from './ts-config';
import { useAmapLevelAndCityNew } from '@/common/hook/useAmapLevelAndCityNew';
import InitEvent from './components/InitEvent';
import { areaList } from '@/common/api/common';
import { changeProvinceCityDistrict } from '@/store/common';
import LeftCon from './components/SiteView/LeftCon';
import { urlParams } from '@lhb/func';
import useUpdateEffect from '@/common/hook/updateEffect/useUpdateEffect';
import { getPCDInfo } from '@/common/utils/map';

const defaultData = {
  level: levelEnum.site,
  provinceId: 11,
  cityId: 87,
};

/**
 * @Description LCN 选址地图
 */
const Siteselectionmapb: FC<{}> = () => {

  const {
    isGreater1440,
    isGreater1920,
  } = InitEvent();// 初始化需要做的事情

  const dispatch = useDispatch();

  const provinceCityDistrict = useSelector((state: any) => state.common.provinceCityDistrict);
  const [mapIns, setMapIns] = useState<any>(null);// 地图实例
  const [collectList, setCollectList] = useState<any[]>([]); // 收藏数量
  const [mapontext, setMapontext] = useState<any>({
    // 工具箱
    toolBox: {
      stadiometry: null, // 测距
      satellite: null, // 卫星地图
    }
  });// 工具箱context

  const { placeCategoryIds, spotCategoryIds, minSpotArea, maxSpotArea, requirementId, industryIds, cityId } = urlParams(location.search);
  const requirementData = { // 需求信息
    requirementId: requirementId, // 需求id
    placeCategoryIds: placeCategoryIds ? decodeURIComponent(placeCategoryIds)?.split(',')?.map(item => +item) : [], // 项目类型
    spotCategoryIds: spotCategoryIds ? decodeURIComponent(spotCategoryIds)?.split(',')?.map(item => +item) : [], // 点位类型
    minSpotArea: !isNaN(+minSpotArea) ? +minSpotArea : null, // 最小面积
    maxSpotArea: !isNaN(+maxSpotArea) ? +maxSpotArea : null, // 最大面积
    industryIds: industryIds ? decodeURIComponent(industryIds)?.split(',')?.map(item => +item) : [], // 行业
    cityId: !isNaN(+cityId) ? +cityId : null, // 城市
  };
  const [checked, setChecked] = useState<any>({
    placeCategory: requirementData.placeCategoryIds,
    spotCategory: requirementData.spotCategoryIds,
    minSpotArea: requirementData.minSpotArea,
    maxSpotArea: requirementData.maxSpotArea,
  });// 左侧已选的筛选项

  const [viewLevel, setViewLevel] = useState<MapView>({
    level: defaultData.level,
    provinceId: 0,
    cityId: requirementData.cityId || defaultData.cityId,
    districtIds: [],
  });

  const [poiData, setPoiData] = useState<any>(null); // 搜索框搜索后选择的poi
  const [curSelectDistrict, setCurSelectDistrict] = useState<curSelectDistrictType>({
    districtInfo: [], // 当前选中的行政区信息
    cacheMapInfo: null, // 缓存选中行政区信息时的mapHelpfulInfo
  });// 当前选中的行政区信息
  const [isShape, setIsShape] = useState<boolean>(false);// 是否选中绘制商圈
  const [isReset, setIsReset] = useState<number>(0); // 是否需要更新数据
  setIsReset;
  const [showLeftCon, setShowLeftCon] = useState<boolean>(true);// 是否展开左侧
  const [rightDrawerVisible, setRightDrawerVisible] = useState<any>(true); // 是否展开右侧列表
  const [isOpenBorder, setIsOpenBorder] = useState<boolean>(true); // 开店区域围栏开关
  const [isOpenSubway, setIsOpenSubway] = useState<boolean>(false);// 是否打开左侧边栏-图层设置-地铁线路

  const [mapShouldHandle] = useState<boolean>(true);

  const [itemData, setItemData] = useState<any>({
    visible: false, // 是否显示详情
    id: null,
    detail: null, // 存放详情相关字段
    isFirst: false
  });// 当前商圈详情
  const [searchParams, setSearchParams] = useState<any>({
    sort: 'desc',
    sortField: null, // 默认评分排序
  }); // 接口入参
  const [districtCluster, setDistrictCluster] = useState<any>({
    data: null,
    isBack: false, // 记录是否是右侧列表点击了返回
  });// 点击区聚合时，记录城市、区数据
  const isSelectDistrictRef = useRef<boolean>(false);// 是否选择了行政区，当选择后为true,并且在5s后或切换城市后会转为false
  const locationInfo = useCurLocation(mapIns, {
    panToLocation: false, // 定位成功后是否自动移动到响应位置
    zoomToAccuracy: false, // 定位成功后是否自动调整级别
    showCircle: false, // 不显示定位的蓝色圈
  }); // 定位信息
  const mapHelpfulInfo = useAmapLevelAndCityNew(mapIns, true, true); // 监听地图相关的数据
  const getProvinceCityDistrict = async() => {
    const cityResult: any = await areaList({ type: 1 });
    dispatch(changeProvinceCityDistrict(cityResult));
  };
  const cityProvinceInfo = useMemo(() => {
    if (!viewLevel?.cityId) return;
    if (!provinceCityDistrict) {
      getProvinceCityDistrict();
      return;
    }
    const info = findCurCItyInfo(provinceCityDistrict, viewLevel?.cityId);
    return {
      ...info,
      level: viewLevel.level,
      districtIds: viewLevel?.districtIds
    };
  }, [viewLevel, provinceCityDistrict]);
    // 当搜索地址后，如果城市不同，则改变城市（目前搜索地址组件只会在”选址“模式）
  useUpdateEffect(() => {
    const { lng, lat } = poiData || {};
    getPCDInfo([lng, lat]).then((val:any) => {
      if (val?.provinceId && val?.cityId &&
           val?.cityId !== viewLevel?.cityId) {
        setViewLevel({
          level: levelEnum.site,
          provinceId: val?.provinceId,
          cityId: val?.cityId
        });
      }
    });
  }, [poiData]);
  // 当不是选址地图时
  useEffect(() => {
    if (viewLevel.level !== levelEnum.site) {
      poiData && setPoiData(null);
    }
  }, [viewLevel.level]);

  return (
    <>
      <div className={cs(styles.container, networkMapContainer)}>

        {/* // 本地做收藏操作，collectList跟随pageList或者本地操作后更新 */}
        <CollectListContext.Provider value={{
          collectList,
          setCollectList,
        }}>
          <MapHelpfulContextProvider
            helpInfo={mapontext}
            stateEvent={setMapontext}
          >
            {/* 顶部视角 */}
            <AllLevelTop
              viewLevel={viewLevel}
              setViewLevel={setViewLevel}
              setChecked={setChecked}
              mapIns={mapIns}
              mapHelpfulInfo={mapHelpfulInfo}
              setPoiData={setPoiData}
              curSelectDistrict={curSelectDistrict}
              setCurSelectDistrict={setCurSelectDistrict}
              isShape={isShape}
              setIsShape={setIsShape}
              isGreater1440={isGreater1440}
              isGreater1920={isGreater1920}
            />
            {/* 地图 */}
            <div className={cs(styles.mapCon, mapCon)}>
              <AMap
                mapOpts={{
                  zooms: [3.5, 20],
                }}
                loaded={setMapIns}
                plugins={[
                  'AMap.RangingTool',
                  'AMap.DistrictSearch',
                  'AMap.Geocoder',
                  'AMap.PlaceSearch',
                  'AMap.HeatMap',
                  'AMap.Driving', // 驾车
                  'AMap.Riding', // 骑行
                  'AMap.Walking', // 走路
                  'AMap.DistrictSearch',
                  'AMap.MarkerCluster', // 聚合插件
                  'AMap.TileLayer', // 卫星图
                  'AMap.HeatMap', // 热力图
                  'AMap.MouseTool', // 鼠标工具-新增商圈
                  'AMap.CircleEditor', // 圆形编辑
                  'AMap.PolygonEditor', // 多边形编辑
                  'AMap.AutoComplete', // 输入提示，提供了根据关键字获得提示信息的功能
                ]}/>
            </div>
            {/* 地图loading */}
            <Loading amapIns={mapIns} delay={400}/>

            {/* 左侧-筛选、图层设置 */}
            {
              levelEnum.site === viewLevel.level
                ? <LeftCon
                  showLeftCon={showLeftCon}
                  setShowLeftCon={setShowLeftCon}
                  cityProvinceInfo={cityProvinceInfo}
                  setItemData={setItemData}
                  setCurSelectDistrict={setCurSelectDistrict}
                  curSelectDistrict={curSelectDistrict}
                  setSearchParams={setSearchParams}
                  setChecked={setChecked}
                  districtCluster={districtCluster} // 点击区聚合时保存的数据
                  checked={checked}
                  isGreater1440={isGreater1440} // 是否大屏幕1440
                  isGreater1920={isGreater1920} // 是否大于1920
                  mapIns={mapIns}
                  isSelectDistrictRef={isSelectDistrictRef}
                  isOpenBorder={isOpenBorder}
                  setIsOpenBorder={setIsOpenBorder}
                  isOpenSubway={isOpenSubway}
                  setIsOpenSubway={setIsOpenSubway}
                  isShape={isShape}// 是否选中绘制商圈
                  setViewLevel={setViewLevel}
                  requirementData={requirementData}
                /> : <></>
            }
            {/* 禁用地图 */}
            <div
              className={styles.mask}
              style={{ display: mapShouldHandle ? 'none' : 'block' }}
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}
            ></div>
            {/* 选址视角 */}
            {
              viewLevel.level === levelEnum.site ? <SiteView
                cityProvinceInfo={cityProvinceInfo}
                viewLevel={viewLevel} // 视图level
                mapIns={mapIns}
                setCollectList={setCollectList}
                locationInfo={locationInfo}
                poiData={poiData}
                level={mapHelpfulInfo.level}
                curSelectDistrict={curSelectDistrict}
                isShape={isShape}
                isReset={isReset}
                showLeftCon={showLeftCon}
                setShowLeftCon={setShowLeftCon}
                rightDrawerVisible={rightDrawerVisible}
                setRightDrawerVisible={setRightDrawerVisible}
                isOpenBorder={isOpenBorder}
                itemData={itemData}
                setItemData={setItemData}
                searchParams={searchParams}
                districtCluster={districtCluster}
                setDistrictCluster={setDistrictCluster}
                isSelectDistrictRef={isSelectDistrictRef}
              /> : <></>
            }

          </MapHelpfulContextProvider>
        </CollectListContext.Provider>
      </div>
    </>
  );
};

export default ({ location }) => (
  <KeepAlive saveScrollPosition='screen' name={location.pathname}>
    <Siteselectionmapb />
  </KeepAlive>
);


